import { useCheckboxState } from '../abstract/checkbox';

export function useDevelopmentFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { checked: development, setChecked: onDevelopmentChange } = useCheckboxState({
    defaultValue: query.development,
    filterKey: `development`,
    queryKey: `dev`,
    setFilters,
    updateQuery,
  });

  return { development, onDevelopmentChange };
}
